/*
  Time Attack PDP Badge + Purchase Control
  Shows LIMITED / ALMOST GONE / SOLD OUT per selected variant.
  Disables ATC button when round is not live or product is not purchasable.
*/
(function () {
  'use strict';

  // Only run on product pages with -time-attack handle
  var handle = window.location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split('?')[0].split('#')[0].replace(/\/$/, '');
  if (handle.indexOf('-time-attack') === -1) return;

  var API_URL = 'https://verish-api.lukuku.co/api/v2/time-attack/today';
  var rawFetch = window.__foxThemeRawFetch || window.fetch;
  var i18nAll = window.PROMO_I18N || {};
  var lang = window.PROMO_LANG || 'en';
  var t = i18nAll[lang] || i18nAll['en'] || {};
  function tr(key, fallback) { return t[key] || fallback || key; }

  var taVariantMap = null;
  var cap = 11;
  var roundState = null; // effective state: pre/live/closing/waiting/closed
  var productPurchasable = false;
  var serverOffset = 0;
  var purchaseDeadline = 0;
  var deadlineTimer = null;

  function getCountry() {
    if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    try {
      var match = document.cookie.match(/(?:^|;\s*)localization=([^;]+)/);
      if (match) return decodeURIComponent(match[1]).trim().toUpperCase();
    } catch (e) {}
    return '';
  }

  function getEffectiveState(round) {
    var state = round.state;
    if (state === 'closed' && round.nextSlotId && round.nextOpenAt) {
      return 'waiting';
    }
    return state;
  }

  function fetchTaData() {
    var country = getCountry();
    var url = API_URL + (country ? '?country=' + encodeURIComponent(country) : '');
    return rawFetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        if (data.serverTime) serverOffset = new Date(data.serverTime).getTime() - Date.now();
        clearTimeout(deadlineTimer);
        purchaseDeadline = 0;
        var allRounds = [];
        if (data.round) allRounds.push(data.round);
        if (data.upcoming) allRounds = allRounds.concat(data.upcoming);

        // Reset state on each fetch — don't carry over stale purchasable
        roundState = null;
        productPurchasable = false;
        taVariantMap = null;

        for (var i = 0; i < allRounds.length; i++) {
          var round = allRounds[i];
          if (!round.products) continue;
          for (var j = 0; j < round.products.length; j++) {
            var p = round.products[j];
            if (p.taHandle === handle) {
              cap = round.capPerVariant || 11;
              roundState = round.state ? getEffectiveState(round) : 'pre';
              productPurchasable = !!p.purchasable;
              purchaseDeadline = round.displayCloseAt ? new Date(round.displayCloseAt).getTime() : 0;
              if (roundState === 'live' && purchaseDeadline > Date.now() + serverOffset) {
                deadlineTimer = setTimeout(function () {
                  updateBadge(getInitialVariantId() || lastVariantId);
                }, purchaseDeadline - Date.now() - serverOffset);
              }
              taVariantMap = {};

              // Draft product — don't treat as permanently gone
              if (p.taStatus === 'DRAFT' || p.taStatus === 'ARCHIVED') {
                productPurchasable = false;
              }

              if (p.variants) {
                p.variants.forEach(function (v) {
                  var id = String(v.taVariantId || '').replace('gid://shopify/ProductVariant/', '');
                  taVariantMap[id] = v.available || 0;
                });
              }
              return;
            }
          }
        }
      })
      .catch(function (e) {
        console.error('[ta-pdp-badge]', e);
        // On API error — disable purchase, don't keep stale state
        roundState = null;
        productPurchasable = false;
        taVariantMap = null;
      });
  }

  // Badge element
  var badgeEl = document.createElement('span');
  badgeEl.className = 'ta-pdp-badge';
  badgeEl.style.display = 'none';
  var badgeInserted = false;

  function insertBadge() {
    if (badgeInserted) return;
    var targets = ['.product__badges', '.product__block--badges', '.product__block--title', '.product__title'];
    for (var i = 0; i < targets.length; i++) {
      var target = document.querySelector(targets[i]);
      if (target) {
        target.parentNode.insertBefore(badgeEl, target);
        badgeInserted = true;
        return;
      }
    }
  }

  // ATC button control
  var originalAtcState = null; // Button label saved on first disable

  function getAtcButton() {
    return document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]');
  }

  var paymentStates = new WeakMap();

  function setPaymentAvailable(btn, available) {
    var form = btn.closest('form');
    if (!form) return;
    form.querySelectorAll('.shopify-payment-button').forEach(function (payment) {
      if (!available) {
        if (!paymentStates.has(payment)) paymentStates.set(payment, payment.style.display);
        payment.style.display = 'none';
      } else if (paymentStates.has(payment)) {
        payment.style.display = paymentStates.get(payment);
        paymentStates.delete(payment);
      }
    });
  }

  function disableAtc(reason) {
    var btn = getAtcButton();
    if (!btn) return;
    // Save original state only once
    if (!originalAtcState) {
      originalAtcState = { text: (btn.querySelector('span') || btn).textContent };
    }
    btn.disabled = true;
    setPaymentAvailable(btn, false);
    btn.setAttribute('data-ta-disabled', 'true');
    if (reason) (btn.querySelector('span') || btn).textContent = reason;
  }

  function enableAtc() {
    var btn = getAtcButton();
    if (!btn) return;
    var optionFields = document.querySelectorAll('product-info [data-field-option="color"], product-info [data-field-option="size"]');
    for (var i = 0; i < optionFields.length; i++) {
      if (!optionFields[i].querySelector('[data-option-value-id]:checked')) {
        btn.disabled = true;
        setPaymentAvailable(btn, false);
        return;
      }
    }
    setPaymentAvailable(btn, true);
    btn.removeAttribute('data-ta-disabled');
    if (originalAtcState) {
      btn.disabled = false;
      var addText = typeof FoxTheme !== 'undefined' && FoxTheme.variantStrings && FoxTheme.variantStrings.addToCart;
      (btn.querySelector('span') || btn).textContent = addText || originalAtcState.text;
      originalAtcState = null;
    }
  }

  function updateBadge(variantId) {
    insertBadge();

    // Purchase control based on round state
    var avail = taVariantMap && taVariantMap[String(variantId)];
    var canPurchase = roundState === 'live' && productPurchasable && avail > 0
      && Date.now() + serverOffset < purchaseDeadline;

    if (!canPurchase) {
      disableAtc(tr('atc_disabled', 'Not available right now'));
    } else {
      enableAtc();
    }

    // Badge display
    if (!taVariantMap) {
      badgeEl.style.display = 'none';
      return;
    }

    if (avail === undefined) {
      badgeEl.style.display = 'none';
      return;
    }

    var almostThreshold = cap > 100 ? 33 : 5;
    badgeEl.style.display = '';

    if (avail <= 0) {
      badgeEl.textContent = tr('sold_out', 'SOLD OUT');
      badgeEl.className = 'ta-pdp-badge ta-pdp-badge--sold';
      disableAtc(tr('sold_out', 'SOLD OUT'));
    } else if (avail <= almostThreshold) {
      badgeEl.textContent = tr('almost_gone', 'ALMOST GONE');
      badgeEl.className = 'ta-pdp-badge ta-pdp-badge--almost';
    } else {
      badgeEl.textContent = tr('limited', 'LIMITED');
      badgeEl.className = 'ta-pdp-badge ta-pdp-badge--limited';
    }
  }

  var lastVariantId = null;

  function getInitialVariantId() {
    var variantInput = document.querySelector('form.main-product-form[action*="/cart/add"] input[name="id"]');
    if (variantInput && variantInput.value) return variantInput.value;
    var selectedVariant = document.querySelector('[data-selected-variant]');
    if (selectedVariant) {
      try { return JSON.parse(selectedVariant.textContent).id; } catch (e) {}
    }
    var urlParams = new URLSearchParams(window.location.search);
    var vid = urlParams.get('variant');
    if (vid) return vid;
    try {
      var productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        var pData = JSON.parse(productJson.textContent);
        if (pData.selected_or_first_available_variant) return pData.selected_or_first_available_variant.id;
        if (pData.variants && pData.variants[0]) return pData.variants[0].id;
      }
    } catch (e) {}
    try {
      var checkedInput = document.querySelector('input[name="id"]:checked, select[name="id"]');
      if (checkedInput) return checkedInput.value;
    } catch (e) {}
    return null;
  }

  function initAndRefresh() {
    fetchTaData().then(function () {
      var vid = lastVariantId || getInitialVariantId();
      if (vid) lastVariantId = vid;
      updateBadge(vid);
    });
  }

  disableAtc(tr('atc_disabled', 'Not available right now'));
  initAndRefresh();
  listen();
  setInterval(initAndRefresh, 10000);

  function listen() {
    document.addEventListener('submit', function (event) {
      var btn = getAtcButton();
      if (!btn || event.target !== btn.closest('form')) return;
      updateBadge(getInitialVariantId() || lastVariantId);
      if (btn.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.variant) {
          lastVariantId = event.data.variant.id;
          updateBadge(lastVariantId);
        }
      });
    }
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        lastVariantId = e.detail.variant.id;
        updateBadge(lastVariantId);
      }
    });
  }
})();
